import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './styles/tokens.css';
import './styles/kontor.css';
import './index.css';
import App from './App';

// Globaler axios-Interceptor: fuegt Auth-Header automatisch zu allen Requests hinzu
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Bei 401 eines eingeloggten Nutzers: ausloggen und zur Login-Seite.
// Ohne auth_token (Login-Seite, 2FA-Schritt, Registrierung) gibt es nichts
// auszuloggen – die Seite behaelt dann ihre Fehlermeldung (Spec 2026-09-02, §5.5).
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const warEingeloggt = !!localStorage.getItem('auth_token');
    if (error.response?.status === 401 && warEingeloggt) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      if (window.location.pathname !== '/login') {
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
